export enum DocEnum {
  WELCOME,
  CREATE_NEW_DRAW,
  CONTINUE_DRAW,
  OPENGUIDE,
  PENCIL,
  BRUSH,
  FEATHER_PEN,
  AEROSOL,
  RECTANGLE,
  ELLIPSE,
  POLYGONE,
  LINE,
  CHOOSE_COLOR,
  APPLICATOR,
  TEXT,
  BUCKET,
  ERASER,
  PIPETTE,
  SELECTION_RECTANGLE,
  DESELECTION,
  SELECTION_MOVE,
  SELECTION_SCALE,
  SELECTION_ROTATE,
  GRID,
  UNDO_REDO,
  MAGNETISM,
  CLIPBOARD,
  SAVE_DRAW,
  EXPORT_DRAW_LOCAL,
  EXPORT_DRAW_MAIL,
  ABOUTUS,
}
